import { ExternalLink, FileText } from 'lucide-react';

import styles from './FilePreview.module.css';

interface FilePreviewProps {
  fileName?: string;
  fileUrl?: string;
  previewUrl?: string;
}

export function FilePreview({ fileName = 'Submitted file', fileUrl, previewUrl }: FilePreviewProps) {
  const isImagePreview = Boolean(previewUrl);

  return (
    <div className={styles.card}>
      {isImagePreview ? (
        <img alt="" className={styles.thumbnail} src={previewUrl} />
      ) : (
        <span className={styles.icon} aria-hidden="true">
          <FileText size={22} strokeWidth={2} />
        </span>
      )}
      <div className={styles.meta}>
        <p className={styles.name}>{fileName}</p>
        {fileUrl ? (
          <a
            className={styles.link}
            href={fileUrl}
            rel="noreferrer"
            target="_blank"
          >
            View submission <ExternalLink aria-hidden="true" size={14} />
          </a>
        ) : null}
      </div>
    </div>
  );
}
